import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;
const dataFormatter = new Jsona();

export default {
    async getPriceindexes(params) {
        const response = await axios.get(API_URL + "/priceindexes", { headers: authHeader(), params: params });
        return { data: dataFormatter.deserialize(response.data), meta: response.data.meta?.page };
    },

    async addPriceindex(priceindex) {
        priceindex.type = "priceindexes"
        const newJson = dataFormatter.serialize({ stuff: priceindex })
        const response = await axios.post(API_URL + "/priceindexes", newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async deletePriceindex(priceindexId) {
        await axios.delete(API_URL + "/priceindexes/" + priceindexId, { headers: authHeader() });
    },

    async getPriceindex(priceindexId) {
        const response = await axios.get(API_URL + "/priceindexes/" + priceindexId, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async editPriceindex(priceindex) {
        priceindex.type = "priceindexes"
        const newJson = dataFormatter.serialize({ stuff: priceindex })
        const response = await axios.patch(API_URL + "/priceindexes/" + priceindex.id, newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },
}




